export default __webpack_public_path__ + "static/media/5-shine.080801eb.png";